module.exports = __webpack_public_path__ + "img/hk.dcfffd1.webp";